import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputTextComponent from "presentation/components/Shared/InputTextComponent";
import { useClientSelectedStore } from "presentation/stores/use-client-selected-store";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { useTripDestinationStore } from "presentation/stores/use-trip-destination-store";
import { useEffect } from "react";

const ClientInfoForm = () => {
  const { client, setClient } = useClientSelectedStore();
  const { clientType, setClientType } = useParameterStore();
  const { tripDestination: tripDestinations, setTripDestination } =
    useTripDestinationStore();

  return (
    <div className="default-grid ">
      <div className="default-2-cols">
        <InputTextComponent
          label="Nome"
          fieldName="name"
          currentObject={client}
          getValue={client?.name}
          setValue={setClient}
        />
      </div>
      <div className="default-1-col">
        <DropdownComponent
          options={tripDestinations}
          label="Cidade"
          fieldName="city"
          currentObject={client}
          getValue={client?.city}
          setValue={setClient}
        />
      </div>
      <div className="default-1-col">
        <DropdownComponent
          options={clientType}
          label="Tipo"
          fieldName="type"
          currentObject={client}
          getValue={client?.type}
          setValue={setClient}
        />
      </div>
    </div>
  );
};

export default ClientInfoForm;
